export const emptyRow = {
  id: null,
dailyMessDetails: [],
  date: "",

  checkIn: "",
  checkOut: "",

  serviceType: "mess",

  mealType: "breakfast",

  stayDays: 1,

  stayRate: "",

  type: "single",

  name: "",

  customerMobileNumber: "",

  address: "",

  count: 1,

  messTotal: 0,

  stayTotal: 0,

  rate: "",

  discount: "",

  paymentStatus: "pending",

  total: 0,

  received: "",

  balance: 0,

  remarks: "",

  roomType: "",

  roomNumber: "",

  isSaved: false,

  isEditing: true,

  errorMsg: "",

  successMsg: "",

  isManualDays: false,
};